import {RESET_CACHE, SET_ERROR} from "./actionTypes";

export const resetCache = (client_id) => {
    if(!client_id){
        console.error('updateSales','no client id provided');
        return {
            type: SET_ERROR,
            error: 'no client id provided'
        };
    }
    return {
        type: RESET_CACHE,
        client_id: client_id
    };
}
